import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { datetimeShortFromUTC } from 'utils/dayjs';
import './index.sass';

const { block, el } = bem('event-chip');
const SimpleEventChip = ({event, number}) => {
    const eventFormat = (utcDate) => {
        const { date, time } = datetimeShortFromUTC(utcDate);
        return `${ date } ${ time }`;
    };

    return (
        <div className={ block() }>
            <Text className={ el('number') }>#{ number + 1 }</Text>
            <Text className={ el('date') }>{ eventFormat(event.startDate) }</Text>
        </div>
    )
}

export default SimpleEventChip;
